namespace RioERP.Invoices {
    export interface InvoicesForm {
        Invoicenumber: Serenity.StringEditor;
        InvoiceDate: Serenity.DateEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        EInvoiceType: Serenity.EnumEditor;
        ESourceType: Serenity.EnumEditor;
        EInvoiceTo: Serenity.EnumEditor;
        CustomerId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        DiscountAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        IsRecalculated: Serenity.BooleanEditor;
        EInvoiceStatus: Serenity.EnumEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingPincode: Serenity.IntegerEditor;
        FreezeData: Serenity.BooleanEditor;
    }

    export class InvoicesForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.Invoices';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoicesForm.init)  {
                InvoicesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.IntegerEditor;

                Q.initFormType(InvoicesForm, [
                    'Invoicenumber', w0,
                    'InvoiceDate', w1,
                    'InvoiceCompanyId', w2,
                    'EInvoiceType', w3,
                    'ESourceType', w3,
                    'EInvoiceTo', w3,
                    'CustomerId', w2,
                    'FranchiseeId', w2,
                    'DiscountAmount', w4,
                    'GrossAmount', w4,
                    'NetAmount', w4,
                    'TaxableAmount', w4,
                    'TaxAmount', w4,
                    'IsRecalculated', w5,
                    'EInvoiceStatus', w3,
                    'BillingAddress1', w0,
                    'BillingAddress2', w0,
                    'BillingCity', w0,
                    'BillingStateId', w2,
                    'BillingPincode', w6,
                    'FreezeData', w5
                ]);
            }
        }
    }
}
